<template>
  <div class="Bigbox">
    <!-- <div class="box2">
      <eight></eight>
    </div> -->
    <div class="box1">
      <one></one>
    </div>
    <div class="box1">
      <two></two>
    </div>
    <div class="box1">
      <three></three>
    </div>
    <div class="box1">
      <four></four>
    </div>
    <div class="box1">
      <five></five>
    </div>
    <div class="box1">
      <six></six>
    </div>
    <div class="box2">
      <seven></seven>
    </div>
  </div>
</template>
<script>
import one from "./assembly/one"; // 工单趋势
import two from "./assembly/two"; // 报修时间分析
import three from "./assembly/three"; // 报修渠道分析
import four from "./assembly/four"; // 工单类型
import five from "./assembly/five"; // 工单原因
import six from "./assembly/six"; // 工单处理情况
import seven from "./assembly/seven"; // 报修量
import eight from "./assembly/eight";
export default {
  components: {
    one,
    two,
    three,
    four,
    five,
    six,
    seven,
    eight,
  },
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.Bigbox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 8px;
}

.box1 {
  border-radius: 10px;
  width: 49%;
  margin-bottom: 20px;
  box-shadow: 0 0 10px #eee;
}

.box2 {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 0 0 10px #eee;
}
</style>
